<template>
  <b-form>
    <div id="enedis-case-tabs">
      <b-card no-body>
        <b-tabs card class="case-tabs-container" v-model="tabIndex">
          <b-tab v-for="(tranche, index) in activeTranches"
                :title="`Dossier ${index + 1}`"
                :key="index"
                class="case-tab-tranche"
                :active="isTabActive(tranche.id)">
            <TrancheType :tranche="tranche" @updated="trancheUpdated()" @archived="trancheArchived()"/>
          </b-tab>

          <b-tab v-if="isAdmin() || isAgent()" title="Nouveau dossier" class="case-tab-new-tranche" ref="newTrancheTab" :active="isTabActive(null)">
            <TrancheCreateType @updateTranches="updateTranches($event)" v-if="!refreshNewTranche"/>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </b-form>
</template>

<script>
import { mapGetters } from 'vuex';
import Clone from 'clone';

const $ = require('jquery');

export default {
  name: 'EnedisCaseType',
  props: {
    tabIndexProp: null,
  },
  data() {
    return {
      tabIndex: 0,
      refreshNewTranche: false,
    };
  },
  computed: {
    trancheListWithPosition() {
      return Clone(this.getEnedisCaseOnGoing().tranches || [])
        .map((t, i) => {
          const newTranche = Clone(t);
          newTranche.position = (i + 1);
          return newTranche;
        })
        .filter(t => !this.trancheIsArchived(t));
    },
    activeTranches() {
      let tranches = _.filter(this.getEnedisCaseOnGoing().tranches, function(o) { return !o.isArchived });

      return tranches;
    }
  },
  methods: {
    ...mapGetters([
      'getTrancheStatusEnumeration',
      'getEnedisCaseOnGoing',
      'isAdmin',
      'isAgent',
    ]),
    trancheIsArchived(tranche) {
      if (tranche.isArchived == true) {
        return true;
      } else {
        return false;
      }
    },
    trancheArchived() {
      this.tabIndex = 0;
    },
    trancheUpdated() {
      // console.log('tranche updated !');
    },
    updateTranches(currentCase) {
      this.$store.commit('setEnedisCaseOnGoing', currentCase);
      // setTimeout(() => {
      //   this.tabIndex = this.activeTranches.length - 1;
      // });
      this.$forceNextTick(() => {
        this.tabIndex = this.activeTranches.length - 1;
      });
    },
    isTabActive(trancheId) {
      if (trancheId == this.$route.params.sliceId) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.case-tabs-parent-container {
  background-color: transparent !important;
  box-shadow: none;
}
.case-tabs-container {
  background-color: transparent;
  margin-bottom: 30px;

  .card-header {
    padding: 0 !important;
    background-color: transparent !important;
    border-radius: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/EnedisCaseType.vue